/**
* 能源计划
*/
const energyPlan = {
  
createEnergyPlan: "/api/createEnergyPlan",//创建
modifyEnergyPlan: "/api/modifyEnergyPlan",//修改
deleteEnergyPlan: "/api/deleteEnergyPlan",//删除
getEnergyPlan: "/api/getEnergyPlan",//查询
addEnergyPlanDesire: "/api/addEnergyPlanDesire",//创建
modifyEnergyPlanDesire: "/api/modifyEnergyPlanDesire",//修改
deleteEnergyPlanDesire: "/api/deleteEnergyPlanDesire",//删除
getEnergyPlanDesires: "/api/getEnergyPlanDesires",//查询
setEnergyPlanDesires: "/api/setEnergyPlanDesires",//设置
reportEnergyPlan: "/api/reportEnergyPlan",//查询计划报告
}

export default energyPlan